import TypesenseInstantSearchAdapter, { TypesenseInstantsearchAdapterOptions } from "typesense-instantsearch-adapter";
import { CustomWindow } from "./../../custom.window";

declare let window: CustomWindow;

type TypesenseClientType = {
  include_fields?: string;
  query_by?: string;
  query_by_weights?: string;
  sort_by?: string;
  prioritize_exact_match?: boolean,
};

const searchAPIKey: string = window.__searchAPIKey ? window.__searchAPIKey : 'R1QxtibUW6S7AUTuc0hAbYpBm7lYEpjl';

export const TypesenseServerSettings =  {
      apiKey: searchAPIKey,
      nodes: [
        {
          host: "4yb13m8reuha0odgp-1.a1.typesense.net",
          port: 443,
          protocol: "https",
        },
        {
          host: "4yb13m8reuha0odgp-2.a1.typesense.net",
          port: 443,
          protocol: "https",
        },
        {
          host: "4yb13m8reuha0odgp-3.a1.typesense.net",
          port: 443,
          protocol: "https",
        },
      ],
      cacheSearchResultsForSeconds: 2 * 60,
    };

const typesenseClient = (props: TypesenseClientType): any => {
  const { 
    include_fields = "title,create_date,slug,content_short,image_url,image_caption,content_rank,content_type,url,categories,tags,main_entry,origin,types,new_icon,id,primary_tag,format_tag", 
    query_by = "content_type,title,content",
    sort_by = "content_rank:desc,_text_match:desc,create_date:desc",
    query_by_weights = "",
    prioritize_exact_match = true,
  } = props;


    // type CustomConfigOptionsType = {
    //   appId?: string;
    //   transporter?: Function,
    //   modified?: string;
    //   addAlgoliaAgent?: Function,
    //   clearCache?: Function
    // }

    // type ConfigOptionsType = TypesenseInstantsearchAdapterOptions & CustomConfigOptionsType & {
    //   modified: Date;
    // }

  const config: TypesenseInstantsearchAdapterOptions = {
    server: TypesenseServerSettings,
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    //  queryBy is required.
    //  filterBy is managed and overridden by InstantSearch.js. To set it, you want to use one of the filter widgets like refinementList or use the `configure` widget.
    additionalSearchParameters: {
      query_by,
      query_by_weights,
      sort_by,
      include_fields,
      prioritize_exact_match,
    },
  };

  const typesenseInstantsearchAdapter: TypesenseInstantSearchAdapter = new TypesenseInstantSearchAdapter(config);

  return typesenseInstantsearchAdapter.searchClient;
}

export default typesenseClient;
